import { useEffect } from 'react'
import type { JSX } from 'react'

import type { SurveyStep } from '../../types'
import { ChannelSelectStep } from '../ChannelSelectStep/ChannelSelectStep'
import { MultiSelectStep } from '../MultiSelectStep/MultiSelectStep'
import { SingleSelectStep } from '../SingleSelectStep/SingleSelectStep'

interface StepRendererProps {
  step: SurveyStep
  initialAnswers: string[]
  initialTextValue?: string
  disabled?: boolean
  loading?: boolean
  error?: string | null
  onDismissError?: () => void
  onSubmit: (answers: string[], textValue?: string) => void
  onSkip: () => void
}

export function StepRenderer({
  step,
  initialAnswers,
  initialTextValue,
  disabled,
  loading,
  error,
  onDismissError,
  onSubmit,
  onSkip,
}: StepRendererProps): JSX.Element | null {
  const isUnknownType =
    step.surveyStepType !== 'singleSelect' &&
    step.surveyStepType !== 'multiSelect' &&
    step.surveyStepType !== 'channelSelect'

  useEffect(() => {
    if (isUnknownType) {
      void onSkip()
    }
  }, [isUnknownType, onSkip])

  const props = {
    step,
    initialAnswers,
    initialTextValue,
    disabled,
    loading,
    error,
    onDismissError,
    onSubmit,
    onSkip,
  }

  switch (step.surveyStepType) {
    case 'singleSelect':
      return <SingleSelectStep key={step.slug} {...props} />
    case 'multiSelect':
      return <MultiSelectStep key={step.slug} {...props} />
    case 'channelSelect':
      return <ChannelSelectStep key={step.slug} {...props} />
    default:
      return null
  }
}
